// @ts-nocheck

/**
 * @param {HTMLElement} container
 */
function pauseInactiveVideos(container) {
  if (!container) return;

  const activeSlide = container.querySelector('.swiper-slide-active');
  const videos = container.querySelectorAll('video');

  videos.forEach((video) => {
    if (!activeSlide || !activeSlide.contains(video)) {
      video.pause();
    }
  });
}

/**
 * @param {HTMLElement} container
 * @param {number} [attempt]
 */
function bindProductMediaGallery(container, attempt = 0) {
  if (!container || container.dataset.mediaGalleryReady === 'true') {
    return;
  }

  const swiper = container.swiperInstance;

  if (!swiper) {
    if (attempt >= 20) {
      return;
    }

    window.setTimeout(() => {
      bindProductMediaGallery(container, attempt + 1);
    }, 60);
    return;
  }

  container.dataset.mediaGalleryReady = 'true';

  swiper.on('slideChangeTransitionStart', () => {
    pauseInactiveVideos(container);
  });
}

function initProductMediaGalleries() {
  const galleries = document.querySelectorAll('[data-product-media-gallery]');

  if (!galleries.length) {
    return;
  }

  galleries.forEach((gallery) => {
    bindProductMediaGallery(gallery);
  });
}

if (!window.__productMediaGalleryBooted) {
  window.__productMediaGalleryBooted = true;

  document.addEventListener('DOMContentLoaded', initProductMediaGalleries);
  document.addEventListener('shopify:section:load', initProductMediaGalleries);
  document.addEventListener(
    'shopify:section:reorder',
    initProductMediaGalleries
  );
  document.addEventListener(
    'shopify:section:select',
    initProductMediaGalleries
  );
  document.addEventListener('shopify:block:select', initProductMediaGalleries);
}

initProductMediaGalleries();
